import styled from '@emotion/styled';
import { Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import React from 'react';

export interface IParagraphPropsProps extends ParagraphProps {}

const Paragraph: React.FC<IParagraphPropsProps> = ({ ...props }) => {
  return <Typography.Paragraph {...props} />;
};

export default styled(Paragraph)``;
